import React from "react";

import async from "../../../components/Async";
import { Container } from "reactstrap";

const Calendar = async(() => import("../Calendar"));

const Default = () => (
  <Container fluid className="p-0">
   <Calendar />
  </Container>
);

export default Default;
